<template>
  <div v-if="comment" class="mt-32">
    <p class="body-1 block whitespace-pre-line">
      {{ displayedText }}
    </p>

    <RevLink v-if="isCommentLong" class="mt-2" @click="onToggleText">
      {{ toggleTextLabel }}
    </RevLink>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'
import { computed, ref, watch } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevLink } from '@ds/components/Link'

import { MAX_COMMENT_LENGTH } from '../../constants'

import translations from './UserComment.translations'

const props = withDefaults(
  defineProps<{
    comment: string
    position: number
    forceExpand?: boolean
  }>(),
  { forceExpand: false },
)

const route = useRoute()
const i18n = useI18n()
const { trackClick } = useTracking()

const cutComment = ref(true)

const isCommentLong = computed(() => props.comment.length > MAX_COMMENT_LENGTH)

const displayedText = computed(() => {
  if (isCommentLong.value && cutComment.value) {
    return `${props.comment.substring(0, MAX_COMMENT_LENGTH)}...`
  }

  return props.comment
})

const toggleTextLabel = computed(() =>
  cutComment.value ? i18n(translations.showMore) : i18n(translations.showLess),
)

function onToggleText() {
  trackClick({
    zone: `review_position_${props.position}`,
    page_type: route.name as string,
    name: cutComment.value ? 'see_more' : 'see_less',
  })

  cutComment.value = !cutComment.value
}

watch(
  () => props.forceExpand,
  () => {
    cutComment.value = !props.forceExpand
  },
)
</script>
